import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ClickAwayListener } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import 'emoji-mart/css/emoji-mart.css'
import { Picker, EmojiData } from 'emoji-mart'

const Emojis = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <>
      <ClickAwayListener
        onClickAway={() => {
          props.open(false)
        }}
      >
        <Picker
          emoji=""
          title=""
          emojiSize={20}
          onClick={props.onClick}
          open={props.open}
          color={theme.palette.primary.main}
          style={{
            border: 0,
            position: 'absolute',
            zIndex: 1000,
            bottom: 80,
            right: 15,
            boxShadow: theme.shadows[6],
            fontSize: theme.typography.fontSize,
            fontFamily: theme.typography.fontFamily,
          }}
          i18n={{
            search: t('emojis.search'),
            clear: t('emojis.clear'),
            notfound: t('emojis.notfound'),
            skintext: t('emojis.skintext'),
            categories: {
              search: t('emojis.categories.search'),
              recent: t('emojis.categories.recent'),
              smileys: t('emojis.categories.smileys'),
              people: t('emojis.categories.people'),
              nature: t('emojiscategories..nature'),
              foods: t('emojis.categories.foods'),
              activity: t('emojis.categories.activity'),
              places: t('emojis.categories.places'),
              objects: t('emojis.categories.objects'),
              symbols: t('emojis.categories.symbols'),
              flags: t('emojis.categories.flags'),
              custom: t('emojis.categories.custom'),
            },
            categorieslabel: t('emojis.categorieslabel'),
            skintones: {
              1: t('emojis.skintones.1'),
              2: t('emojis.skintones.2'),
              3: t('emojis.skintones.3'),
              4: t('emojis.skintones.4'),
              5: t('emojis.skintones.5'),
              6: t('emojis.skintones.6'),
            },
          }}
        />
      </ClickAwayListener>
    </>
  )
}

export default memo(Emojis)
